<template>
  <p
    :class="extraClasses"
    :style="{ fontFamily: randomFont }"
    @click="$emit('click')"
  >
    <slot></slot>
  </p>
</template>

<script>
export default {
  props: {
    extraClasses: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      randomFont: "",
      fonts: [
        "'Special Elite', system-ui",
        "'Syne Mono', monospace",
        "'Galada', cursive",
        "'Limelight', sans-serif",
        "'Markazi Text', serif",
        "'Lemur', sans-serif",
      ],
    };
  },
  mounted() {
    this.randomFont = this.getRandomFont();
  },
  methods: {
    getRandomFont() {
      const randomIndex = Math.floor(Math.random() * this.fonts.length);
      return this.fonts[randomIndex];
    },
  },
};
</script>
